export default {"src":"/_next/static/media/search-gradient.9c7b0ee4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};